import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    main: {
      height: '100vh',
      display: 'flex',
      padding: theme.spacing(0),
      margin: theme.spacing(0),
      justifyContent: 'center',
      alignItems: 'center',
    },
    card: {
      width: '48rem',
      margin: theme.spacing(0),
      '& > *': {
        alignItems: 'start',
        padding: theme.spacing(0, 1),
      },
    },
    message: {
      margin: theme.spacing(12, 0),
      alignSelf: 'center',
    },
    title: {
      fontWeight: 'bold',
    },
    errorIcon: {
      color: theme.palette.error.main,
      marginRight: theme.spacing(1),
    },
    errorContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    errorText: {
      color: theme.palette.error.main,
    },
  }),
)
